import { Clock, Mail, MessageSquare, MessageSquareText, Phone, Plus } from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { SequenceStepType } from '@/models/sequence'

interface AddStepMenuProps {
  onAdd: (type: SequenceStepType) => void
  disabled?: boolean
}

export function AddStepMenu({ onAdd, disabled }: AddStepMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" disabled={disabled} className="text-md">
          <Plus className="mr-1 size-4" /> Add step
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        <DropdownMenuItem onClick={() => onAdd(SequenceStepType.SEND_EMAIL)}>
          <Mail className="mr-2 size-4" /> Send email
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onAdd(SequenceStepType.SEND_SMS)}>
          <MessageSquareText className="mr-2 size-4" /> Send SMS
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onAdd(SequenceStepType.CALL)}>
          <Phone className="mr-2 size-4" /> Call reminder
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onAdd(SequenceStepType.TEXT)}>
          <MessageSquare className="mr-2 size-4" /> Text reminder
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onAdd(SequenceStepType.WAIT)}>
          <Clock className="mr-2 size-4" /> Wait
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
